import { render, staticRenderFns } from "./CommunityFeeTypeTree.vue?vue&type=template&id=1511df96&scoped=true"
import script from "./CommunityFeeTypeTree.vue?vue&type=script&lang=js"
export * from "./CommunityFeeTypeTree.vue?vue&type=script&lang=js"
import style0 from "./CommunityFeeTypeTree.vue?vue&type=style&index=0&id=1511df96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1511df96",
  null
  
)

export default component.exports